module.exports = __webpack_public_path__ + "img/intervista_scalfari.a04a73d2.jpg";